import { createContext } from "react";

export interface IMainTourContext {
  currentStep: number;
  startTour: () => void;
  isRunning: boolean;
  // NOTE: Index of the first tour step whose target lives inside the
  // account menu, so the menu can hold itself open for that whole run.
  userMenuStepIndex: number;
}

export const MainTourContext = createContext<IMainTourContext | null>(null);
